import React from 'react';
import { ArrowUpRight } from 'lucide-react';

export const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-40 px-6 lg:px-12 border-t border-white/10 overflow-hidden">
      {/* Subtle background grid */}
      <div className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1.5 h-1.5 bg-brand-primary animate-pulse-dot" />
          <span className="font-manrope text-xs uppercase tracking-[0.3em] text-white/60">
            07 &mdash; Let&apos;s Build
          </span>
        </div>

        <h2
          data-testid="contact-headline"
          className="font-outfit font-black tracking-tighter text-white leading-[0.85] text-[18vw] sm:text-[15vw] lg:text-[12rem] xl:text-[14rem]"
        >
          Let&apos;s <span className="italic font-light text-brand-primary">build</span><br />
          something<br />
          <span className="outline-text">real.</span>
        </h2>

        <div className="mt-16 grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-6">
            <p className="font-manrope text-base lg:text-xl text-white/70 leading-relaxed max-w-xl">
              Tell us about your business, your ambitions, and where things are stuck.
              We respond personally within one business day.
            </p>
          </div>
          <div className="lg:col-span-6 flex flex-col sm:flex-row gap-4 lg:justify-end">
            <a
              href="mailto:info@elevadigital.com.au?subject=Project%20Inquiry&body=Hi%20ELEVA%20Digital%2C%0A%0AI'd%20like%20to%20discuss%20a%20project%3A%0A%0AAbout%20us%3A%0AWhat%20we%20need%3A%0ATimeline%3A%0ABudget%20range%3A%0A%0AThanks!"
              data-testid="contact-primary-mailto"
              className="group inline-flex items-center gap-3 bg-brand-primary text-black font-manrope font-semibold uppercase tracking-wider text-sm px-8 py-5 hover:bg-white transition-colors duration-300"
            >
              info@elevadigital.com.au
              <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href="mailto:info@elevadigital.com.au?subject=Strategy%20Call%20Request"
              data-testid="contact-secondary-mailto"
              className="inline-flex items-center gap-3 bg-transparent border border-white/20 text-white font-manrope font-semibold uppercase tracking-wider text-sm px-8 py-5 hover:bg-white hover:text-black transition-colors duration-300"
            >
              Book a Strategy Call
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
